export default __webpack_public_path__ + "static/media/11.15c4f3c2.png";